import { assert } from 'console';
import React, { useState } from 'react';

const Login = () => {
    const [id, setId] = useState('');
    const [password, setPassowrd] = useState('');
    const [error, setError] = useState('');

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        const res: Response = await fetch('/api/login', {
            method: 'POST',
            body: new URLSearchParams({id, password}),
        });

        if (res.status == 200) {
            sessionStorage.setItem('loggedIn', 'true');
            sessionStorage.setItem('userId', id);
            window.location.href = '/';
        } else {
            setError('아이디 또는 비밀번호가 틀렸습니다.');
        }
    };

    return(
        <div>
            <div className='title-box'>
            <h1 className='maintitle'>관리자 로그인</h1>
            </div>
            <form onSubmit={handleLogin}>
                <input
                type='text'
                placeholder='아이디'
                value={id}
                onChange={(e) => setId(e.target.value)}
                className="idinput"
                />
                <input
                type='password'
                placeholder='비밀번호'
                value={password}
                onChange={(e) => setPassowrd(e.target.value)}
                className="passwordinput"
                />
                <div className="sign-box">
                <button className='sign-button'>로그인</button>
                </div>
                {error && <p className='err-message'>{error}</p>}
            </form>
        </div>
    )
}

export default Login;
